import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { LinkColors, MyLink, SkeletonLoading } from '@app/shared';
import { DefaultProps } from '@app/Types/global.interfaces';

import { fetchListNews } from '@entities/News/module/services/fetchListNews';

import { News } from '@entities/News/module/types/newsSchema';

import { selectRegion } from '@redux/slices/header';
import { getIsLoaded } from '@entities/News/module/selectors/getIsloaded';
import { getListNews } from '@entities/News/module/selectors/getListNews';
import classNames from 'classnames';

import styles from './blockNewsUser.module.scss';

export const BlockNewsUser = ({ className }: DefaultProps) => {
  const dispatch = useAppDispatch();
  const { REGION: regionId } = useAppSelector(selectRegion);
  const isLoaded = useAppSelector(getIsLoaded);
  const news = useAppSelector(getListNews);
  useEffect(() => {
    if (!isLoaded) {
      dispatch(fetchListNews({ regionId: +regionId, limit: 5, type: [1, 3] }));
    }
  }, [isLoaded]);

  if (!isLoaded) {
    return <BlockNewsUser.Skeleton />;
  }

  return (
    <div className={classNames(styles.Wrapper, className)}>
      <div className={styles.Header}>
        <div className={styles.Title}>Новости</div>
        <MyLink href={'/news/'}>Все новости</MyLink>
      </div>
      {news.slice(0, 6).map(item => (
        <BlockNewsUser.ItemNew key={item.title} {...item} />
      ))}
    </div>
  );
};

BlockNewsUser.ItemNew = function ItemNews({ title, code }: News) {
  return (
    <MyLink color={LinkColors.Black} className={styles.WrapperNewItem} href={`/news/detail/${code}`}>
      <div className={styles.Text}>{title}</div>
    </MyLink>
  );
};

BlockNewsUser.Skeleton = function Skeleton() {
  return <SkeletonLoading width={'100%'} height={'100%'} />;
};
